import type { SVGProps } from 'react';
const SvgSignalCellularConnectedNoInternet4Bar = (
  props: SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#signal_cellular_connected_no_internet_4_bar_svg__a)">
      <path
        fill="currentColor"
        d="M20 18h2v-8h-2v8Zm0 4h2v-2h-2v2ZM2 22h16V8h4V2L2 22Z"
      />
    </g>
    <defs>
      <clipPath id="signal_cellular_connected_no_internet_4_bar_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSignalCellularConnectedNoInternet4Bar;
